const initialState = {
  cache: {},
  list: [],
  listTotal: 0,
  listVersion: 0,
  listState: 'idle',
  archive: [],
  archiveTotal: 0,
  archiveVersion: 0,
  archiveState: 'idle',
  intercomTypes: [],
  intercomPrivateTypes: [{ code: 'GATE', name: 'Калитка/шлагбаум', hasRange: false }],
  buildingTypes: [{ code: 'APARTMENT_HOUSE', name: 'Многоквартирный дом' }, { code: 'PRIVATE_HOUSE', name: 'Частный дом' }],
};

function buildingsReducer(state = initialState, action) {
  // console.log(action);
  switch (action.type) {
    case 'buildings/intercomTypes': {
      return {
        ...state,
        intercomTypes: action.data,
      };
    }
    case 'buildings/buildingTypes': {
      return {
        ...state,
        buildingTypes: action.data,
      };
    }
    case 'buildings/list': {
      return {
        ...state,
        list: action.data.content,
        listTotal: action.data.pageable.totalElements,
        listState: 'success'
      };
    }
    case 'buildings/refresh': {
      return {
        ...state,
        listVersion: state.listVersion + 1,
        listState: 'refresh',
        archiveVersion: state.archiveVersion + 1,
        archiveState: 'refresh',
      };
    }
    case 'buildings/archive': {
      return {
        ...state,
        archive: action.data.content,
        archiveTotal: action.data.pageable.totalElements,
        archiveState: 'success',
      };
    }
    case 'buildings/cache': {
      return {
        ...state,
        cache: { ...state.cache, [action.data.id]: action.data },
      };
    }
    case 'buildings/listState': {
      return {
        ...state,
        listState: 'refresh',
      };
    }
    case 'buildings/archiveState': {
      return {
        ...state,
        archiveState: 'refresh',
      };
    }
    default:
      return state;
  }
}

export default buildingsReducer;
